import router from '@/router/index'

const whiteList = ['/login']

const hqOnlyPaths = ['/school', '/adminAccount', '/deliveryConfig']

function getUserInfo() {
  try {
    return JSON.parse(window.sessionStorage.getItem('userInfo') || '{}')
  } catch (error) {
    return {}
  }
}

function isHeadquarter(userInfo) {
  return (userInfo.roleType || '').toUpperCase() === 'HQ'
}

router.beforeEach((to, from, next) => {
  const token = window.sessionStorage.getItem('token')
  if (!token) {
    if (whiteList.includes(to.path)) {
      next()
    } else {
      next('/login')
    }
    return
  }

  if (to.path === '/login') {
    next('/')
    return
  }

  const userInfo = getUserInfo()
  if (hqOnlyPaths.includes(to.path) && !isHeadquarter(userInfo)) {
    next('/home')
    return
  }

  next()
})
